import {PAYLOAD_FIELDS_NAMES} from './constants';
import {FIELD_TYPES, STANDARD_FIELD_TYPES} from '../utils';
import {SelectOptionType} from '../utils/types';

type CreateGuestPayload = {
  [PAYLOAD_FIELDS_NAMES.id]?: string;
  [PAYLOAD_FIELDS_NAMES.reservation_id]: string;
  [PAYLOAD_FIELDS_NAMES.name]?: string;
  [PAYLOAD_FIELDS_NAMES.surname]?: string;
  [PAYLOAD_FIELDS_NAMES.second_surname]?: string;
  [PAYLOAD_FIELDS_NAMES.gender]?: string | number;
  [PAYLOAD_FIELDS_NAMES.birth_date]?: string;
  [PAYLOAD_FIELDS_NAMES.nationality]?: string | number;
  [PAYLOAD_FIELDS_NAMES.document_type]?: string | number;
  [PAYLOAD_FIELDS_NAMES.document_number]?: string | number;
  [PAYLOAD_FIELDS_NAMES.visa_number]?: string;
  [PAYLOAD_FIELDS_NAMES.birth_place_country]?: string | number;
  [PAYLOAD_FIELDS_NAMES.residence_country]?: string | number;
  [PAYLOAD_FIELDS_NAMES.residence_city]?: string;
  [PAYLOAD_FIELDS_NAMES.residence_municipality]?: string;
  [PAYLOAD_FIELDS_NAMES.residence_address]?: string;
  [PAYLOAD_FIELDS_NAMES.birth_place_city]?: string;
  [PAYLOAD_FIELDS_NAMES.birth_place_municipality]?: string;
  [PAYLOAD_FIELDS_NAMES.birth_place_address]?: string;
  [PAYLOAD_FIELDS_NAMES.document_issue_date]?: Date | string;
  [PAYLOAD_FIELDS_NAMES.document_expiration_date]?: Date | string;
  [PAYLOAD_FIELDS_NAMES.document_expedition_country]?: string | number;
  [PAYLOAD_FIELDS_NAMES.document_expedition_city]?: string;
  [PAYLOAD_FIELDS_NAMES.document_expedition_municipality]?: string;
  [PAYLOAD_FIELDS_NAMES.next_destination_country]?: string | number;
  [PAYLOAD_FIELDS_NAMES.next_destination_municipality]?: string | number;
  [PAYLOAD_FIELDS_NAMES.residence_postal_code]?: string;
  [PAYLOAD_FIELDS_NAMES.citizenship]?: string | number;
  [PAYLOAD_FIELDS_NAMES.purpose_of_stay]?: string | number;
  [PAYLOAD_FIELDS_NAMES.arrived_from_country]?: string | number;
  [PAYLOAD_FIELDS_NAMES.arrived_from_district]?: string | number;
  [PAYLOAD_FIELDS_NAMES.arrived_from_municipality]?: string | number;
  [PAYLOAD_FIELDS_NAMES.next_destination_district]?: string | number;
  [PAYLOAD_FIELDS_NAMES.residence_province]?: string;
  [PAYLOAD_FIELDS_NAMES.phone]?: string;
  [PAYLOAD_FIELDS_NAMES.second_phone]?: string;
  [PAYLOAD_FIELDS_NAMES.email]?: string;
  [PAYLOAD_FIELDS_NAMES.signature]?: string | Blob;
  [PAYLOAD_FIELDS_NAMES.tax_exemption]?: string | number;
  [PAYLOAD_FIELDS_NAMES.full_tourist_tax]?: string;
  [PAYLOAD_FIELDS_NAMES.arrived_from_province]?: string;
  [PAYLOAD_FIELDS_NAMES.next_destination_province]?: string;
  [PAYLOAD_FIELDS_NAMES.next_destination_address]?: string;
  [PAYLOAD_FIELDS_NAMES.document_support_number]?: string;
  [PAYLOAD_FIELDS_NAMES.kinship_relationship]?: string;
  [PAYLOAD_FIELDS_NAMES.external_category_id]?: string | number;
  [PAYLOAD_FIELDS_NAMES.fiscal_code]?: string;
  [PAYLOAD_FIELDS_NAMES.document_front_side_scan]?: Blob;
  [PAYLOAD_FIELDS_NAMES.document_back_side_scan]?: Blob;
  [PAYLOAD_FIELDS_NAMES.biomatch_doc_id]?: string; //posible remove
  [PAYLOAD_FIELDS_NAMES.biomatch_doc]?: Blob;
  [PAYLOAD_FIELDS_NAMES.biomatch_passed]?: boolean;
  [PAYLOAD_FIELDS_NAMES.biomatch_selfie]?: Blob;
  [PAYLOAD_FIELDS_NAMES.ocr_passed]?: boolean;
  [PAYLOAD_FIELDS_NAMES.external_documents_front_side_scan]?: string;
  [PAYLOAD_FIELDS_NAMES.external_documents_front_side_scan_service]?: IMAGE_SERVICE_ORIGIN;
  [PAYLOAD_FIELDS_NAMES.external_documents_biomatch_doc]?: string;
  [PAYLOAD_FIELDS_NAMES.external_documents_biomatch_doc_service]?: IMAGE_SERVICE_ORIGIN;
  [PAYLOAD_FIELDS_NAMES.external_documents_back_side_scan]?: string;
  [PAYLOAD_FIELDS_NAMES.external_documents_back_side_scan_service]?: IMAGE_SERVICE_ORIGIN;
  [PAYLOAD_FIELDS_NAMES.external_documents_biomatch_selfie]?: string;
  [PAYLOAD_FIELDS_NAMES.external_documents_biomatch_selfie_service]?: IMAGE_SERVICE_ORIGIN;
};

type GetGuestSchemaPayload = {
  [PAYLOAD_FIELDS_NAMES.reservation_id]: string;
  [PAYLOAD_FIELDS_NAMES.nationality]?: string;
  [PAYLOAD_FIELDS_NAMES.birth_place_country]?: string;
  [PAYLOAD_FIELDS_NAMES.document_expedition_country]?: string;
  [PAYLOAD_FIELDS_NAMES.next_destination_country]?: string;
  [PAYLOAD_FIELDS_NAMES.arrived_from_country]?: string;
  [PAYLOAD_FIELDS_NAMES.residence_country]?: string;
  [PAYLOAD_FIELDS_NAMES.document_type]?: string;
  [PAYLOAD_FIELDS_NAMES.citizenship]?: string;
  [PAYLOAD_FIELDS_NAMES.birth_date]?: string;
  [PAYLOAD_FIELDS_NAMES.phone]?: boolean;
};

type FormField = {
  name: string;
  type: STANDARD_FIELD_TYPES;
  placeholder: string;
  required: boolean;
  active: boolean;
  order: number;
  options?: SelectOptionType[];
  endpoint?: string;
  refetch?: boolean;
  format?: string;
};

type DocumentChoice = {
  label: string;
  value: string;
  two_sides: boolean;
  without_mrz: boolean;
};

type IdentityVerificationDetails = {
  required: boolean;
  verification_type: 'OCR' | 'BIOMATCH' | 'DOCUMENT';
  document_choices: DocumentChoice[];
};

export type CustomField = {
  field_type: FIELD_TYPES;
  id: string;
  is_custom: boolean;
  is_required: boolean;
  name: string;
  names: {[key: string]: string}[];
  placeholders: {[key: string]: string}[];
};

type CustomForm = {
  country: string;
  fields_set: {
    form_id: string;
    id: string;
    order: number;
    is_required: boolean;
    is_leaders_field: boolean;
    field: CustomField;
  }[];
  housings: string[];
  id: string;
  name: string;
  required_id_or_passport: boolean;
};

type GuestSchemaResponse = {
  custom: CustomForm;
  default: FormField[];
  iv: IdentityVerificationDetails;
};

type CreateFields = {
  data: {[p: string]: string | boolean | number};
  guest_id: string;
  form_id: string;
};

export enum IMAGE_SERVICE_ORIGIN {
  ocr = 'ocr',
  biomatch = 'biomatch',
}

export type {
  CreateGuestPayload,
  GetGuestSchemaPayload,
  FormField,
  GuestSchemaResponse,
  CustomForm,
  CreateFields,
};
